export const environment = {
  production: true,
  enableNotificationDebug: false
};